module.exports = __webpack_public_path__ + "6869eb879f845b660fe065eb78d9e05d.svg";